import { ChangeEvent } from 'react';
import { InputAdornment, makeStyles, Paper, TextField } from '@material-ui/core';

type Props = {
  value: number;
  onChange: (value: number) => void;
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',

    '& > h4': {
      margin: 0,
      opacity: 0.7,
    },
  },

  paper: {
    padding: theme.spacing(2),
    height: 'fit-content',
  },
}));

export function DeliveryCostSection({ value, onChange }: Props) {
  const classes = useStyles();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const raw = event.target.value;
    if (raw === '') {
      onChange(0);
      return;
    }
    const parsed = Number(raw);
    if (Number.isNaN(parsed) || parsed < 0) return;
    onChange(parsed);
  };

  return (
    <section className={classes.root}>
      <h4>Frais de livraison :</h4>
      <Paper className={classes.paper}>
        <TextField
          type="number"
          variant="outlined"
          fullWidth
          value={value}
          onChange={handleChange}
          InputProps={{
            endAdornment: <InputAdornment position="end">€</InputAdornment>,
            inputProps: { min: 0, step: 0.01 },
          }}
        />
      </Paper>
    </section>
  );
}
